import { render, staticRenderFns } from "./AddSettings.vue?vue&type=template&id=5eba1448"
import script from "./AddSettings.vue?vue&type=script&lang=js"
export * from "./AddSettings.vue?vue&type=script&lang=js"
import style0 from "./AddSettings.vue?vue&type=style&index=0&id=5eba1448&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports